module.exports = __webpack_public_path__ + "static/media/logo-marinamunch-square-white.465cfdff.png";